<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.507 17.507">
    <g transform="translate(.75 .75)" stroke="currentColor" stroke-width="1.5">
      <circle cx="8" cy="8" r="8" fill="#fff"/>
      <path d="M8 0a8 8 0 1 1-8 8h8Z" fill="currentColor"/>
    </g>
  </svg>
</template>
